__webpack_require__.p = "https://c.d2cgo.com/dtc_center/v19/auth_assets/";